import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetTimeOut, SaveTimeOut } from "./app_config_slice";
import { sessionUser } from "../../Util/common";
import { KendoLoader } from "../../Kendo/kendo_loader";

export const Timeout = ({ selTab }) => {
  const [timeoutValue, setTimeoutValue] = useState(1);
  const [id, setId] = useState(0);
  const [Loading, setLoading] = useState(false);
  const { setTimeValue, settingTimeValue } = useSelector(
    (state) => state.appConfig
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(GetTimeOut());
  }, []);
  useEffect(() => {
    if (setTimeValue != 0) {
      setId(setTimeValue);
    }
  }, [setTimeValue]);
  useEffect(() => {
    if (settingTimeValue != null && settingTimeValue != undefined) {
      const settingvalue = settingTimeValue.SettingValue;
      const settingid = settingTimeValue.SettingID;
      if (settingvalue != null) {
        setTimeoutValue(parseInt(settingvalue));
      }
      if (settingid != null) {
        setId(settingid);
      }
    }
  }, [settingTimeValue]);
  const handleChange = () => {
    setLoading(true);
    dispatch(
      SaveTimeOut({
        intialId: id > 0 ? id : 0,
        timeValue: timeoutValue != "" ? timeoutValue : 1,
        SavedBy: sessionUser(),
      })
    );
    dispatch(GetTimeOut());
    setLoading(false);
  };

  return (
    <>
      <div className="row input-block mb-3">
        <div className="col-md-3 p-0 ms-2">
          <label className="form-label">
            Inquiry Form Time Out <span className="text-danger">*</span>
          </label>
          <input
            type="number"
            min={1}
            max={99}
            className="form-control field"
            name="TypeName"
            id="TypeName"
            placeholder="In Minutes"
            data-required="true"
            value={timeoutValue}
            onChange={(e) => {
              const value = e.target.value;

              if (/^\d*$/.test(value) && value.length <= 2) {
                const numericValue = parseInt(value, 10);

                if (numericValue >= 1 && numericValue <= 99) {
                  setTimeoutValue(value);
                } else if (!value) {
                  setTimeoutValue("");
                }
              }
            }}
            onKeyPress={(e) => {
              const charCode = e.key.charCodeAt(0);
              if (charCode < 48 || charCode > 57) {
                e.preventDefault();
              }
            }}
            onBlur={handleChange}
            // onKeyPress={isDecimalNum}
          />
        </div>
        <div className="col-md-2 mt-4 pt-1 me-2">
          <span className="form-label">In minutes</span>
        </div>
      </div>
      <div className="row input-block mb-3">
        {Loading && (
          <KendoLoader className="d-flex justify-content-start align-items-center" />
        )}
      </div>
    </>
  );
};
